export enum PaymentMethod {
  Cash = 1,
  CreditCard = 2,
  Transfer = 3,
  Payroll = 4,
  Other = 5,
}
